<template>
    <div>
			<!--面包屑导航区域-->
            <div class="crumbs">
            	<el-breadcrumb separator="/">
				<el-breadcrumb-item>
              <i class="el-icon-s-data"></i> 视频缴费统计
			  </el-breadcrumb-item>
            </el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query" >
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								<el-input v-model="query.parentTel" clearable :placeholder="'请输入家长电话号'" class="handle-input mr10" style="width: 13%;"></el-input>
								<el-input v-model="query.childName" clearable :placeholder="'请输入宝宝名称'" class="handle-input mr10" style="width: 13%;"></el-input>
								<el-select v-model="query.valueSBASAAI" clearable filterable
								:placeholder="'请选择所属幼儿园'" class="handle-select mr10" style="width: 15%;">
								  <el-option
								  	v-for="item in query.optionsSBASAAI"
								  	:key="item.SAAMSID"
								  	:label="item.SAANAME"
								  	:value="item.SAAMSID">
								  </el-option>
								</el-select>
								<el-select v-model="query.valueCCBSTAT" clearable
								:placeholder="'请选择缴费类型'" class="handle-select mr10" style="width: 11%;">
								  <el-option
								  	v-for="item in query.optionsCCBSTAT"
								  	:key="item.INIKEY2"
								  	:label="item.INIDISP"
								  	:value="item.INIKEY2">
								  </el-option>
								</el-select>
								<el-select v-model="query.valueCCBCZLX" clearable :placeholder="'请选择支付方式'" class="select-shop mr10" style="width: 11%;">
									<el-option 
									 v-for="item in query.optionsCCBCZLX" 
									 :key="item.INIKEY2" 
									 :label="item.INIDISP" 
									 :value="item.INIKEY2">
									</el-option>
								</el-select>
								<el-date-picker style="width: 14%;" v-model="query.start" type="datetime" :picker-options="starttime" value-format=" yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" class="handle-input mr10" :placeholder="'缴费时间范围1'"/>
									<span style="margin-right: 0.8%;">-</span>
									<el-date-picker style="width: 14%;" v-model="query.end" type="datetime" :picker-options="endTime" value-format=" yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" class="handle-input mr10" :placeholder="'缴费时间范围2'"/>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" class="float" icon="el-icon-search"@click="handleSearch">搜索</el-button>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<el-button type="primary" :disabled="!hasPerms(buttonPerms.exportPerms)" icon="el-icon-download" @click="tableToExcel">导出Excel</el-button>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								
							</div>
						</el-col>
					</el-row>
				</div>
				
				<el-table ref="datalist" 
				:data="tableData" 
				border class="table" 
				:default-sort="{prop: 'CCBINDT', order: 'descending'}"
				 @sort-change="changeTableSort"
				 header-cell-class-name="table-header" 
				 @selection-change="handleSelectionChange" 
				 :row-key="getRowKeys" 
				 v-loading="loading">
					<el-table-column type="selection" :reserve-selection="true" align="center" width="50"></el-table-column>
					<el-table-column type="index" :label="'序号'" width="80" align="center"></el-table-column>
					<el-table-column prop="CCBMSID" :label="'ID'"align="center" v-if='show' width="150"></el-table-column>
					<el-table-column prop="HAAPHON" :label="'手机号'" align="center" ></el-table-column>
					<el-table-column prop="HABNAME" :label="'宝宝名称'" align="center" ></el-table-column>
					<el-table-column prop="SABNAME" :label="'班级名称'" align="center" ></el-table-column>
					<el-table-column prop="SAANAME" :label="'幼儿园名称'" align="center" ></el-table-column>
					<el-table-column prop="INIDISP" :label="'缴费类型'" align="center" ></el-table-column>
					<el-table-column prop="CCBSTDT" :label="'续费前到期时间'" align="center"></el-table-column>
					<el-table-column prop="CCBEDDT" :label="'续费后到期时间'" align="center"></el-table-column>
					<el-table-column prop="CCBPAYM" :label="'缴费金额'" align="center" ></el-table-column>
					<el-table-column :label="'支付方式'" align="center">
						<template slot-scope="scope">		
							<span v-if="scope.row.CCBCZLX == 1" style="color:#67C23A;">{{ scope.row.INIDISPCZLX }}</span>
							<span v-if="scope.row.CCBCZLX == 2" style="color:#909399;">{{ scope.row.INIDISPCZLX }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="CCBADDT" :label="'获得天数'" align="center" ></el-table-column>	
					<el-table-column prop="CCBINDT" :label="'缴费时间'" align="center" sortable="custom"></el-table-column>
					<el-table-column :label="'操作'" width="80" align="center">
						<template slot-scope="scope">
							<el-button type="text" 
							:disabled="!hasPerms(buttonPerms.editPerms)" 
							icon="el-icon-edit" 
							@click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, prev, pager, next, jumper" :current-page="this.query.pageIndex"
					 :page-size="this.query.pageSize" :total="this.pageTotal" @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
				</div>
			</el-form>
		</div>
		
		<el-dialog :title="'修改视频到期时间'" width="40%" v-if="showEditTime"
		:visible.sync="showEditTime" :close-on-click-modal="false">
			<el-form :model="ruleForm" :rules="dataRule" ref="ruleForm"  label-width="40%">
				<el-form-item  :label="'修改前：'" prop="sEDDT">
					<el-date-picker
						:clearable="false"
						:editable="false"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm"
						format="yyyy-MM-dd HH:mm"
						v-model="ruleForm.sEDDTOld"
						disabled
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				
				<el-form-item  :label="'修改后：'" prop="sEDDT">
					<el-date-picker
						:clearable="false"
						:editable="false"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm"
						format="yyyy-MM-dd HH:mm"
						v-model="ruleForm.sEDDT"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
			
			<span slot="footer" class="dialog-footer">
				<el-button  @click="showEditTime = false">关闭</el-button>
				<el-button  type="primary" @click="editTime('ruleForm')">保存</el-button>
			</span>
		</el-dialog>
		
    </div>
</template>
<script>
import {
		hasPermission
	} from '@/permission/index.js'
	export default {
		name: 'monitorCCBList',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					searchPerms: 'monitorCCB:monitorCCBList:search', //搜索权限标识
					exportPerms: 'monitorCCB:monitorCCBList:export', //导出权限标识
					editPerms: 'record:recordList:edit', //编辑权限标识
					disabled: false
				},
				
				web_suuid: sessionStorage.getItem("ms_web_suuid"), 
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户
				
				// 开始时间
				starttime: {
					disabledDate: time => {
					  if (this.query.end) {
						return (
						  time.getTime() > new Date(this.query.end).getTime()
						)
					  } else {
						// 不能大于当前日期
						return time.getTime() > Date.now()
					  }
					}
				},
				
				// 结束时间
				endTime: {
					disabledDate: time => {
						// return new Date(+new Date(new Date().toLocaleDateString()) + 24 * 60 * 60 * 1000 - 1);
					  if (this.query.start) {
						return (
						  time.getTime() > Date.now() ||
						  time.getTime() < new Date(this.query.start).getTime() - 8.64e6  
						)
					  } else {
						//return time.getTime() > Date.now()
						
					  }
					}
				},
				
				query: {
					parentTel:'', 		//家长电话号
					childName:'', 		//宝宝名称
					valueSBASAAI:'', 	//幼儿园名称
					optionsSBASAAI: '',
					valueCCBSTAT:'', 	//缴费类型
					optionsCCBSTAT: '',
					valueCCBCZLX:'', 	//支付方式
					optionsCCBCZLX: '',
					start: new Date(new Date(new Date().setDate(1)).toLocaleDateString()), //缴费开始时间
					end: new Date(+new Date(new Date().toLocaleDateString()) + 24 * 60 * 60 * 1000 - 1),  //缴费结束时间
					pageIndex: 1, 		//当前页
					pageSize: 10 		//这是当前每页显示的条数
				},
				tableData: [],
				multipleSelection: [], // 多选操作
				pageTotal: 0, // 总条数
				loading: false,
				showEditTime :false,
				ruleForm: {
					sCCAMSID: '',
					sEDDT: '',
					sEDDTOld: ''
				},
				
				dataRule: {
					sEDDT:[{
						required: true,
						message: '请选择到期时间',
						trigger: ['blur', 'change'],
					}],
				},
				
			};
		},
		created() {
			
			let curpagenum = this.query.pageIndex; //当前页码
			this.show=false;
		
			this.getSAA(); //获取幼儿园
			this.getStat(); //获取缴费类型
			this.getCZLX(); //获取支付方式
			
			this.getData(curpagenum); //获取当前列表数据
			this.get_CCB_List_Count(); //获取当前列表条数
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {
			changeTableSort (column) {
				var sortingType = column.order // ascending null "descending"
				if (sortingType === 'ascending') { // 升
					this.query.sort=column.prop+" ASC ";
				} else if (sortingType === 'descending') { // 降
					this.query.sort=column.prop+" DESC ";
				} 
				// 请求列表数据 sortParam
				this.getData(this.query.pageIndex);
			},
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			//时间格式化
			dateFormat:function(val){
			　  var t=new Date(val);//row 表示一行数据, date 表示要格式化的字段名称
			　　var year=t.getFullYear(),
			　　 month=t.getMonth()+1,
			　　 day=t.getDate(),
			　　  hour=t.getHours(),
			　　  min=t.getMinutes();
			　　 var newTime=year+'-'+
			　　  (month<10?'0'+month:month)+'-'+
			　　   (day<10?'0'+day:day)+' '+
			　　  (hour<10?'0'+hour:hour)+':'+
			　　  (min<10?'0'+min:min);
			　　return newTime;
			},
			//获取缴费类型
			getStat() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sINIKEY1: 10011
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.query.optionsCCBSTAT = response.data.KKDT;
						
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取缴费类型失败',
						type: 'error'
					});
				});
			},
			//获取支付方式
			getCZLX() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sINIKEY1: 10012 
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.query.optionsCCBCZLX = response.data.KKDT;
					}
				})
				.catch((error) => {
					this.$message({
						message: '获取支付方式失败', 
						type: 'error'
					});
				});
			},
			//获取幼儿园信息
			getSAA(){
				const self_agent = this;
				var postUrl='WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
					//请求的url
						postUrl,
					//请求参数
					{ 
						sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if(resCount>0){
						this.query.optionsSBASAAI = response.data.KKDT;
					}		
				})
				.catch((error) =>{
					this.$message({
					  message: '获取幼儿园信息请求失败',  
					  type: 'error'
					});
				});	
			},
			// 获取当前列表条数
			get_CCB_List_Count() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcCCB.svc/Get_CCB_List_Count';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
						sHAAPHON: self_count.query.parentTel.trim(),
						sHABNAME: self_count.query.childName.trim(),
						sSAAI: self_count.query.valueSBASAAI,
						sSTAT: self_count.query.valueCCBSTAT,
						sCZLX: self_count.query.valueCCBCZLX,
						sSTARTDATE: this.dateFormat(self_count.query.start),
						sENDDATE: this.dateFormat(self_count.query.end)
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					this.pageTotal = Number(resCount); //总条数
				})
				.catch((error) => {
					this.$message({
						message: '获取视频缴费统计失败', 
						type: 'error'
					});
				});
			},
			// 获取视频缴费统计数据
			getData(curpage) {
				this.loading = true; //初始化加载loading效果
				const self_count = this;
				var postUrl = 'WCF/WEB/svcCCB.svc/Get_CCB_List';
				//debugger;
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
						sHAAPHON: self_count.query.parentTel.trim(),
						sHABNAME: self_count.query.childName.trim(),
						sSAAI: self_count.query.valueSBASAAI,
						sSTAT: self_count.query.valueCCBSTAT,
						sCZLX: self_count.query.valueCCBCZLX,
						sSTARTDATE: this.dateFormat(self_count.query.start),
						sENDDATE: this.dateFormat(self_count.query.end),
						sSORT: self_count.query.sort,
						sPageIndex: curpage, //页码
						sPageSize: self_count.query.pageSize //每页显示条数
				
					})
				.then((response) => {
					this.loading = false; //取消loading效果
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					let resKKDT = response.data.KKDT;
					if (resCount > 0) {
						//渲染数据 List
						this.tableData = resKKDT; //数据数组
					} else {
						this.tableData = []; //数据数组
					}
				})
				.catch((error) => {
					this.loading = false; //取消loading效果
					this.$message({
						message: '获取视频缴费统计失败', 
						type: 'error'
					});
				});
			},
			// 触发搜索按钮
			handleSearch() {
				
				let sSTARTDATE = this.query.start;
				let sENDDATE = this.query.end;
				
				if(sSTARTDATE === null && sENDDATE !== null)
				{
					this.$alert('请选择缴费时间范围1', '提示', {
					  confirmButtonText: '确定',
					  callback: action => {
					  }
					});
					
					return false;
				}
				else if(sSTARTDATE !== null && sENDDATE === null)
				{
					this.$alert('请选择缴费时间范围2', '提示', {
					  confirmButtonText: '确定',
					  callback: action => {
					  }
					});
					
					return false;
				}
				else if(sSTARTDATE === null && sENDDATE === null)
				{
					this.$alert('请选择缴费时间范围1和缴费时间范围2', '提示', {
					  confirmButtonText: '确定',
					  callback: action => {
					  }
					});
					
					return false;
				}
				
				this.$set(this.query, 'pageIndex', 1);

				this.getData(1);
				this.get_CCB_List_Count(); //获取当前列表条数
				
				this.multipleSelection = []
				this.$refs.datalist.clearSelection();//清空列表多选框
				
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 分页导航 currentPage 改变时会触发
			handlePageChange(currentPage) {
				this.$set(this.query, 'pageIndex', currentPage);
				// 调取列表的函数，初始化时调一次
				this.getData(currentPage);
			},
			//pageSize 改变时会触发
			handleSizeChange(size) {
				this.$set(this.query, 'pageIndex', 1);
				this.$set(this.query, 'pageSize', size);
				// 调取列表的函数，初始化时调一次
				this.getData(size);
			},
			// 导出
			tableToExcel() {
				
				const length = this.multipleSelection.length;
				
				if (length > 0)
				{				
					this.$confirm('此操作将导出excel文件, 是否继续?', '提示', {
						confirmButtonText: '确定', //确定
						cancelButtonText: '取消', //取消
						type: 'warning'
					}).then(() => {
						if(this.multipleSelection == ""){	
							this.excelData = this.tableData //你要导出的数据list。 tableData
						}
						else{
							this.excelData = this.multipleSelection //你要导出的数据list。 multipleSelection
						}
						//this.export2Excel()
						this.export2ExcelStyle()
					}).catch(() => {  
						console.log('cancel'); //取消
					});
				}
				else
				{
					this.$confirm('请勾选要导出的数据', {
							type: 'warning'
						})
						.then(() => {})
						.catch(() => {});
				}
			},
			export2Excel() {
				require.ensure([], () => {
					const {
						export_json_to_excel
					} = require('../../vendor/Export2Excel'); //这里必须使用绝对路径
					const tHeader = ['手机号', '宝宝名称', '幼儿园名称', '缴费类型', '续费前到期时间', '续费后到期时间', '缴费金额','支付方式', '获得天数', '缴费时间']; // 导出的表头名
					const filterVal = ['HAAPHON', 'HABNAME', 'SAANAME', 'INIDISP', 'CCBSTDT', 'CCBEDDT', 'CCBPAYM', 'INIDISPCZLX', 'CCBADDT', 'CCBINDT']; // 导出的表头字段名
					const list = this.excelData;
					const data = this.formatJson(filterVal, list);
					export_json_to_excel(tHeader, data, '视频缴费统计'); // 导出的表格名称，根据需要自己命名					
				})
			},
			export2ExcelStyle(){
				import('@/vendor/Export2ExcelStyle').then(excel => {
					
					const tHeader = ['手机号', '宝宝名称','班级名称', '幼儿园名称', '缴费类型', '续费前到期时间', '续费后到期时间', '缴费金额','支付方式', '获得天数', '缴费时间']; // 导出的表头名
					const filterVal = ['HAAPHON', 'HABNAME','SABNAME', 'SAANAME', 'INIDISP', 'CCBSTDT', 'CCBEDDT', 'CCBPAYM', 'INIDISPCZLX', 'CCBADDT', 'CCBINDT']; // 导出的表头字段名
					
					const list = this.excelData
					const data = this.formatJson(filterVal, list)
					
					data.map(item => {
						// console.log(item)
						item.map((i, index) => {
							if (!i) {
								item[index] = ''
							}
						})
					})
					
					// console.log(data)
					
					excel.export_json_to_excel({
						titleName: "视频缴费统计报表",//视频缴费统计报表
						header: tHeader,
						data,
						border: true,
						filename: "视频缴费统计", //班级名
						autoWidth: true,
						bookType: 'xlsx'
					})
					
				})
				
				
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			getRowKeys(row) {
				return row.CCBMSID; // id为列表数据的唯一标识
			},
			
			handleEdit(index, row) {
				var self = this;
				
				var postUrl = 'WCF/WEB/svcCCB.svc/CheckCCAList';
				//网络请求接口
				self.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
						sMSID: row.CCAMSID
					}
				)
				.then((response) => {
					let resStatus = response.status; //200 代表请求成功
					let resKKSTR = response.data.KKSTR;
					
					if (resStatus == "200") {
						if (resKKSTR == "N") {
							self.$message({
								message: '当前家长,宝宝或幼儿园已失效,无法修改视频到期时间。',
								type: 'error'
							});
							return;
						} else if (resKKSTR == "Y") {
							self.ruleForm.sCCAMSID = row.CCAMSID;
							self.ruleForm.sEDDT = row.CCAEDDT;
							self.ruleForm.sEDDTOld = row.CCAEDDT;
							self.showEditTime = true;
						}
					} else {
						self.$message({
							message: '请求失败', //请求失败
							type: 'error'
						});
					}
					
				})
				.catch((error) => {
					self.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
				
			},
			editTime(formName){
				const self = this;
				
				self.$confirm('是否确认修改？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					self.$refs[formName].validate((valid) => {
						if (!valid) {
							self.$message({
								message: '提交失败', //表单验证失败
								type: 'error'
							});
							return;
						}
						var postUrl = 'WCF/WEB/svcCCB.svc/UpdateCCBInfo';
						//网络请求接口
						self.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
								sCCAID: self.ruleForm.sCCAMSID,
								sEDDT: self.ruleForm.sEDDT
							}
						)
						.then((response) => {
							//请求成功返回的数据
							let resStatus = response.status; //200 代表请求成功
							let resKKSTR = response.data.KKSTR;
						
							if (resStatus == "200") {
								if (resKKSTR == "N") {
									self.$message({
										message: '修改失败', //新增失败
										type: 'error'
									});
								} else if (resKKSTR == "Y") {
									self.$message.success('修改成功,请到第一页查看修改记录'); // 操作成功
									self.sellVisble = false;
									self.$refs['ruleForm'].resetFields()
									
									//self.query.start = new Date(new Date(new Date().setDate(1)).toLocaleDateString())
									//self.query.end = new Date(new Date().getTime())
									
									// self.reload();
									// self.getData(1);
									// self.get_CCB_List_Count();
									self.showEditTime = false;
									this.getData(this.query.pageIndex); //获取当前列表数据
									this.get_CCB_List_Count(); //获取当前列表条数
									
								}
							} else { 
								self.$message({
									message: '请求失败', //请求失败
									type: 'error'
								});
							}
						})
						.catch((error) => {
							self.$message({
								message: '请求失败', //请求失败
								type: 'error'
							});
						});
					});
				});
				
			},
			
		}
	};
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 250px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>